import { js_utils } from "../utils/frfr-js-utils";
import { _cnc_vars_value_korektor_v1 } from "./ter-cnc-program-vars-codec-lib";
import { sastavnica_internal_key_to_excel_key_translations } from "./ter-sastavnica-columns-lib";



// NOVO MULTITRANSLATOR UTILS


//
export const multitranslator_v1_napravi_novi_prazan_recnik = () => {
  // const new_recnik_ref = {};
  const new_recnik_ref = {
    thisis: "RECNIK",
    subrecnik: {},
    extra_arr: [] //
  };

  return new_recnik_ref;
};


//
export const multitranslator_v1_get_recnik_entity = (recnik, subrecnik_id, entity_key) => {
  //
  const KEY_NAME = subrecnik_id;
  if (recnik && recnik.thisis === "RECNIK" && recnik.subrecnik) {
    const subrecnik_id = KEY_NAME;
    if (recnik.subrecnik[subrecnik_id]) {
      if (recnik.subrecnik[subrecnik_id][entity_key]) {
        return recnik.subrecnik[subrecnik_id][entity_key]; // entity found
      } else {
        // recnik_entity not found in subrecnik
        // 2) searching in recnik.extra_arr
        let bingo_entity = false;
        let finished = false;
        let i = 0;
        let maxi = recnik.extra_arr.length - 1;
        while (i <= maxi && finished === false) {
          const recnik_entity = recnik.extra_arr[i];
          if (KEY_NAME in recnik_entity && recnik_entity[KEY_NAME] === entity_key) {
            bingo_entity = {
              ...recnik_entity
            };
            finished = true;
          }
          i++;
        } // end of while
        return bingo_entity;
      }
    } else {
      // subrecnik not found
    }
  } else {
    // invalid recnik
  }
  return {};
};


const _OLD_multitranslator_v1_get_recnik_entity_by_sasint_key = (recnik, virtel_key) => {
  // return recnik[virtel_key];
  if (recnik && recnik.thisis === "RECNIK" && recnik.subrecnik) {
    if (recnik.subrecnik["virtel_key"]) {
      return recnik.subrecnik["virtel_key"];
    } else {
      // subrecnik not found
    }
  } else {
    // invalid recnik
  }
  return {};
};

// TODO
const _EXPERIMENTAL_2_multitranslator_v1_get_recnik_entity_by_sasint_key = (recnik, sasint_key) => {
  const recnik_obj_keys = Object.keys(recnik.obj);
  let bingo_entity = false;
  //
  let finished = false;
  // 1) searching in recnik.obj;
  let i = 0;
  let maxi = recnik_obj_keys.length - 1;
  while (i <= maxi && finished === false) {
    const recnik_entity_key = recnik_obj_keys[i];
    const recnik_entity = recnik_obj_keys[recnik_entity_key];
    if (sasint_key in recnik_entity) {
      bingo_entity = {
        ...recnik_entity
      };
      finished = true;
    }
    i++;
  }
  return bingo_entity;
};


//
const _EXPERIMENTAL_multitranslator_get_prevod_by_sasint_key = (recnik, sasint_key) => {
  const recnik_obj_keys = Object.keys(recnik.obj);
  let bingo_entity = false;
  //
  let finished = false;
  // 1) searching in recnik.obj;
  let i = 0;
  let maxi = recnik_obj_keys.length - 1;
  while (i <= maxi && finished === false) {
    const recnik_entity_key = recnik_obj_keys[i];
    const recnik_entity = recnik_obj_keys[recnik_entity_key];
    if (sasint_key in recnik_entity) {
      bingo_entity = {
        ...recnik_entity
      };
      finished = true;
    }
    i++;
  }
  if (finished === false) {
    // 2) searching in recnik.extra_arr
    let ii = 0;
    let maxii = recnik.extra_arr.length - 1;
    while (i <= maxi && finished === false) {
      const recnik_entity = recnik.extra_arr[i];
      if (sasint_key in recnik_entity) {
        bingo_entity = {
          ...recnik_entity
        };
        finished = true;
      }
      i++;
    }
  }
  return bingo_entity;
};


//
export const multitranslator_v1_dodaj_multiprevod_u_recnik = (recnik_ref, multiprevod) => {
  // dodaje prevod u recnik_ref
  /*
  // multiprevod
  {
    virtel_key,
    value,
    sasint_key, 
    cncvars_key,
  }
  */
  //
  const new_entity = {};
  //
  if ('value' in multiprevod) {
    new_entity.value = multiprevod.value;
  }
  if (typeof multiprevod.sasint_key === 'string') {
    new_entity.sasint_key = multiprevod.sasint_key;
    // automatski dodajemo i prevod za sastavnica export excel
    if (js_utils.is_string_not_empty(sastavnica_internal_key_to_excel_key_translations[multiprevod.sasint_key])) {
      new_entity.sasexcel_key = sastavnica_internal_key_to_excel_key_translations[multiprevod.sasint_key];
    }
    if ('sasint_value' in multiprevod) {
      new_entity.sasint_value = multiprevod.sasint_value;
    }
  }
  if (typeof multiprevod.cncvars_key === 'string') {
    new_entity.cncvars_key = multiprevod.cncvars_key;
    if ('ncvars_value' in multiprevod) {
      new_entity.cncvars_value = multiprevod.ncvars_value;
    } else {
      // ako nema ncvars_value automatski dodajemo sa korekcijom
      if ('value' in multiprevod) {
        const _korekcija_cncvars = _cnc_vars_value_korektor_v1(multiprevod.value);
        if (_korekcija_cncvars[0] === true) {
          new_entity.cncvars_value = _korekcija_cncvars[1];
        }
      }
    }
  }
  //
  // finalizujemo dodavanje u recnik
  if ('by' in multiprevod && multiprevod.by in multiprevod) {
    const subrecnik_id = multiprevod.by;
    if (recnik_ref.subrecnik[subrecnik_id]) {
      // subrecnik_id already exist
      // CASE UPDATE subrecnik
      // do nothing
    } else {
      // CASE CREATE subrecnik
      recnik_ref.subrecnik[subrecnik_id] = {};
    }
    // adding entity properties to subrecnik
    const entity_key = multiprevod[multiprevod.by];
    if (recnik_ref.subrecnik[subrecnik_id][entity_key]) {
      // CASE UPDATE entity
      recnik_ref.subrecnik[subrecnik_id][entity_key] = {
        ...recnik_ref.subrecnik[subrecnik_id][entity_key],
        ...new_entity
      };
    } else {
      // CASE CREATE entity
      recnik_ref.subrecnik[subrecnik_id][entity_key] = {
        ...new_entity
      };
    }
  } else {
    // INVALID multiprevod
  }
  ////////
  /*
  if ('virtel_key' in multiprevod) {
    // CASE with virtel_key
    if (multiprevod.virtel_key in recnik_ref) {
      // key already exist
      // do nothing
    } else {
      recnik_ref.obj_by_virtel_key[multiprevod.virtel_key] = {
        virtel_key: multiprevod.virtel_key
      };
    }
    recnik_ref.obj_by_virtel_key[multiprevod.virtel_key] = {
      ...recnik_ref.obj_by_virtel_key[multiprevod.virtel_key],
      ...new_entity
    };
  } else {
    // CASE without virtel_key
    if ('key' in multiprevod) {
      if (multiprevod.key in recnik_ref) {
        // key already exist
        // do nothing
      } else {
        recnik_ref.obj_by_key[multiprevod.key] = {
          key: multiprevod.key
        };
      }
      recnik_ref[multiprevod.key] = {
        ...recnik_ref.obj_by_key[multiprevod.key],
        ...new_entity
      };
    } else {
      // prevod nece biti dodat u recnik ukoliko nema ni virtel_key ni key
    }
  }
  // TODO kako cemo znati koji je key ukoliko nije virtel_key ???
  */
  //
  return recnik_ref;
};


//
export const multitranslator_v2_napravi_novi_prazan_recnikKljuceva = () => {
  // const new_recnik_ref = {};
  const new_recnik_ref = {
    thisis: "RECNIK_KLJUCEVA",
    subrecnik: {},
    // extra_arr: [] //
  };
  return new_recnik_ref;
};


//
export const multitranslator_v2_extract_superlang_from_jezik = (_jezik) => {
  //
  let superlang;
  if (typeof _jezik === 'string') {
    const arr = _jezik.split('/');
    if (arr.length > 1) {
      superlang = arr[0];
    } else {
      superlang = _jezik;
    }
  }
  return superlang;
};


//
/*
const multitranslator_v2_translate_values = (recnik_kljuceva, _jezik, keygroup_from, keygroup_to, keyvals_from)=>{
  // keygroup_from na primer "virtel_key"
  let translated_obj = {};
  Object.keys(keyvals_from).forEach((keyname_from)=>{
    // keyname_from na primer "ppv_h4"
    // keygroup_to na primer "sasint_key"
    /////
    Object.keys(keyvals_from).forEach((keyname_from)=>{
      const multiprevodJednogKljuca = multitranslator_v2_get_multiprevodJednogKljuca(recnik_kljuceva, "virtel_key", _jezik, keygroup_from, keyname_from);
      if (multiprevodJednogKljuca && multiprevodJednogKljuca[keygroup_from]) {
        const keyname_to = multiprevodJednogKljuca[keygroup_to];
        // const keyname_to = multiprevodJednogKljuca[keygroup_to];   
      } else {
      }
    });
  });
  return translated_obj;
};
*/


//
export const multitranslator_v2_get_multiprevodJednogKljuca = (recnik, subrecnik_id, _jezik, keygroup_from, keyname_from) => {
  // console.log('multitranslator_v2_get_multiprevodJednogKljuca - subrecnik_id, keygroup_from, keyname_from', subrecnik_id, keygroup_from, keyname_from); 
  // na primer subrecnik_id, keygroup_from, keyname_from
  // virtel_key sasint_key Par1
  let bingo_multiprevodJednogKljuca = null;
  //
  // multitranslator_v2_get_multiprevodJednogKljuca(recnik, "virtel_key", "sasint_key", "Par7");
  /*
{thisis: 'RECNIK_KLJUCEVA', subrecnik: {…}}
subrecnik:
  virtel_key:
    ppv_b:
      cncvars_key: "$B$"
      sasexcel_key: "p"
      sasint_key: "Par1"
      _sublang_arr: ['terkk$ppv_sekcija/OJACANJE_H']
      [[Prototype]]: Object
    ppv_b1:
      cncvars_key: "$B1$"
      sasexcel_key: "q"
      sasint_key: "Par2"
      _sublang_arr: (2) ['terkk$ppv_sekcija/1D', 'terkk$ppv_sekcija/4D_LEVO']
      [[Prototype]]: Object
  */
  // const KEY_NAME = subrecnik_id;
  let is_sublang = false;
  const superlang = multitranslator_v2_extract_superlang_from_jezik(_jezik);
  if (_jezik !== superlang) {
    is_sublang = true;
  }
  //
  if (recnik && recnik.thisis === "RECNIK_KLJUCEVA" && recnik.subrecnik) {
    // console.log('recnik.subrecnik', recnik.subrecnik);
    // const subrecnik_id = KEY_NAME;
    if (recnik.subrecnik[subrecnik_id]) {
      // console.log('recnik.subrecnik[subrecnik_id]', recnik.subrecnik[subrecnik_id]);
      ////
      Object.keys(recnik.subrecnik[subrecnik_id]).forEach((entity_key) => {
        const entity = recnik.subrecnik[subrecnik_id][entity_key]
        if (entity && entity[keygroup_from]) {
          // multiprevodJednogKljuca
          if (is_sublang === true) {
            // CASE with sublang
            if (entity[keygroup_from] === keyname_from && entity._sublang_arr.includes(_jezik)) {
              // BINGO
              // console.log('BINGO', entity);
              bingo_multiprevodJednogKljuca = {
                ...entity,
                virtel_key: entity_key
              };
            }
          } else {
            // CASE without sublang
            if (entity[keygroup_from] === keyname_from) {
              // na primer entity["sasint_key"] === "Par1"
              // BINGO
              // console.log('BINGO', entity);
              bingo_multiprevodJednogKljuca = {
                ...entity,
                virtel_key: entity_key
              };
            }
          }
        }
      });
    } else {
      // subrecnik not found
    }
  } else {
    // invalid recnik
  }
  return bingo_multiprevodJednogKljuca;
};


//
const _combine_arrays_of_keys = (arr, new_arr) => {
  const combined_arr = [...arr];
  new_arr.forEach((key) => {
    if (combined_arr.includes(key)) {
      // skip
    } else {
      combined_arr.push(key);
    }
  });
  return combined_arr
};


/*
// TODO
const _combine_sublangs = (old_sublang_obj, sublang_arr)=>{
  const combined_arr = [...arr];
  new_arr.forEach((key)=>{
    if (combined_arr.includes(key)) {
      // skip
    } else {
      combined_arr.push(key);
    }
  });
  return combined_arr
};
*/


//
export const multitranslator_v2_dodaj_multiprevodJednogKljuca_u_recnikKljuceva = (recnik_ref, superlang, sublang_arr, multiprevodJednogKljuca) => {
  //
  const new_entity = {};
  //
  if (typeof multiprevodJednogKljuca.virtel_key === 'string') {
    new_entity.virtel_key = multiprevodJednogKljuca.virtel_key;
  }
  if (typeof multiprevodJednogKljuca.sasint_key === 'string') {
    new_entity.sasint_key = multiprevodJednogKljuca.sasint_key;
    // automatski dodajemo i prevod za sastavnica export excel
    if (js_utils.is_string_not_empty(sastavnica_internal_key_to_excel_key_translations[multiprevodJednogKljuca.sasint_key])) {
      new_entity.sasexcel_key = sastavnica_internal_key_to_excel_key_translations[multiprevodJednogKljuca.sasint_key];
    }
    /*
    if ('sasint_value' in multiprevodJednogKljuca) {
      new_entity.sasint_value = multiprevodJednogKljuca.sasint_value;
    }
    */
  }
  if (typeof multiprevodJednogKljuca.cncvars_key === 'string') {
    new_entity.cncvars_key = multiprevodJednogKljuca.cncvars_key;
    /*
    if ('ncvars_value' in multiprevodJednogKljuca) {
      new_entity.cncvars_value = multiprevodJednogKljuca.ncvars_value;
    } else {
      // ako nema ncvars_value automatski dodajemo sa korekcijom
      if ('value' in multiprevodJednogKljuca) {
        const _korekcija_cncvars = _cnc_vars_value_korektor_v1(multiprevodJednogKljuca.value);
        if (_korekcija_cncvars[0] === true) {
          new_entity.cncvars_value = _korekcija_cncvars[1];
        }
      }
    }
    */
  }
  if (typeof multiprevodJednogKljuca.description === 'string') {
    new_entity.description = multiprevodJednogKljuca.description;
  }
  //
  // finalizujemo dodavanje u recnik
  if ('by' in multiprevodJednogKljuca && multiprevodJednogKljuca.by in multiprevodJednogKljuca) {
    const subrecnik_id = multiprevodJednogKljuca.by;
    if (recnik_ref.subrecnik[subrecnik_id]) {
      // subrecnik_id already exist
      // CASE UPDATE subrecnik
      // do nothing
    } else {
      // CASE CREATE subrecnik
      recnik_ref.subrecnik[subrecnik_id] = {};
    }
    //
    //
    let _sublang_arr = [];
    if (Array.isArray(sublang_arr)) {
      _sublang_arr = sublang_arr;
    }
    // adding entity properties to subrecnik
    const entity_key = multiprevodJednogKljuca[multiprevodJednogKljuca.by];
    if (recnik_ref.subrecnik[subrecnik_id][entity_key]) {
      // CASE UPDATE entity
      recnik_ref.subrecnik[subrecnik_id][entity_key] = {
        ...recnik_ref.subrecnik[subrecnik_id][entity_key],
        ...new_entity,
        _sublang_arr: _combine_arrays_of_keys(recnik_ref.subrecnik[subrecnik_id][entity_key], _sublang_arr),
      };
    } else {
      // CASE CREATE entity
      recnik_ref.subrecnik[subrecnik_id][entity_key] = {
        ...new_entity,
        _sublang_arr
      };
    }
  } else {
    // INVALID multiprevodJednogKljuca
  }
  //
  return recnik_ref;
};